<template lang="pug">
  div.search-result
</template>
<script>
export default {
  name: 'SearchResult'
}
</script>
<style lang="scss" scoped>
.search-result {

}
</style>
